import { useRouteError, Link } from "react-router-dom";
import { Button } from "@/shared/ui/button.jsx";

/**
 * Última barreira contra tela branca: qualquer erro não tratado numa rota
 * cai aqui em vez de derrubar o app inteiro.
 */
export function ErrorPage() {
  const erro = useRouteError();
  console.error(erro);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <div className="max-w-md text-center">
        <h1 className="font-display text-xl font-semibold tracking-tight">
          Esta página não carregou
        </h1>
        <p className="mt-2 text-sm text-muted-foreground">
          Algo deu errado do nosso lado. Tente recarregar ou volte ao início.
        </p>
        {import.meta.env.DEV && erro?.message && (
          <pre className="mt-4 overflow-x-auto rounded-lg bg-muted p-3 text-left text-xs text-muted-foreground">
            {erro.message}
          </pre>
        )}
        <div className="mt-6 flex flex-wrap justify-center gap-2">
          <Button onClick={() => window.location.reload()}>Tentar novamente</Button>
          <Button asChild variant="outline">
            <Link to="/">Voltar ao início</Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
